module.exports = __webpack_public_path__ + "img/loginBanner.d97b7261.png";